/** @type {import('@nuxt/types').Plugin} */
export default ({ app, env, redirect }) => {
    if (app.$tidalAuth.user && app.$tidalAuth.user.countryCode === 'AU') {
        redirect(302, `${env.MY_TIDAL_ORIGIN}/login?noRedirect=true`);
    }
};
